import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseFillCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M20 4C11.161 4 4 11.161 4 20s7.161 16 16 16 16-7.161 16-16S28.839 4 20 4Zm7.806 20.258c.323.258.323.774 0 1.097L25.29 27.87c-.322.323-.838.323-1.096 0L20 23.613l-4.258 4.258c-.258.323-.774.323-1.097 0l-2.516-2.58c-.322-.259-.322-.775 0-1.098L16.387 20l-4.258-4.194c-.322-.258-.322-.774 0-1.096l2.58-2.517c.259-.322.775-.322 1.098 0L20 16.387l4.194-4.194c.258-.322.774-.322 1.096 0l2.517 2.517c.322.322.322.838 0 1.096L23.613 20l4.194 4.258Z" })
});
export default SvgCloseFillCircle;
